module.exports = __webpack_public_path__ + "static/media/Signoras Bakery hero.69fd3483.jpg";